import React from 'react';
import RegistrationCompletedCard from './RegistrationCompletedCard';

const RegistrationCompletedView = () => (
    <div
        className="account"
        style={{ marginTop: '5px !important', padding: '20px 30px !important' }}
    >
        <div className="account__wrapper">
            <div
                className="account__card shadow"
                style={{ padding: '30px 40px' }}
            >
                <RegistrationCompletedCard />
            </div>
        </div>
    </div>
);

export default RegistrationCompletedView;
